const DeNames = ['hsu', 'thuta', 'babe', 'khlayy'];
export const [h, ...w] = DeNames;

const DeArrValue = ['one', 'two', 'three'];
export const [t, , s] = DeArrValue;

const DeArr = [1, 2, 3];
export let [Dx, Dy, Dz] = DeArr;

const DePerson = {
	Dename: 'thuta',
	age: 21,
	gender: 'male',
};
export const { Dename, ...DeRest } = DePerson;

// Swaping Variables
let DeName1 = 'hsu';
let DeName2 = 'thuta';
[DeName1, DeName2] = [DeName2, DeName1];

const displayFullName = (person: {
	firstName: string;
	lastName: string;
}): string => `${person.firstName} ${person.lastName}`;

let DePERSON = { firstName: 'thuta', lastName: 'sann' };
export const DeFuncPerson = displayFullName(DePERSON);
